import {Potions} from "./potions.js"

export class Player {
  constructor(player, setup) {
    this.player = player;
    this.setup = setup;

    this.potions = new Potions(this.player, this.setup);
  }


  weaponTypes = {

    "axe": 'melee',
    "blunt": 'melee',
    "bludgeon": 'melee',
    "bulwark": 'melee',
    "claw": 'melee',
    "polearm": 'melee',
    "pickaxe": 'melee',
    "scythe": 'melee',
    "slash_sword": 'melee',
    "spear": 'melee',
    "spiked": 'melee',
    "stab_sword": 'melee',
    "2h_sword": 'melee',
    "whip": 'melee',
    "staff": 'melee',
    "bladed_staff": 'melee',
    "banner": 'melee',
    "polestaff": 'melee',
    "salamander": 'melee',
    "unarmed": 'melee',

    "powered_staff": 'magic',

    "bow": 'ranged',
    "chinchompas": 'ranged',
    "crossbow": 'ranged',
    "thrown": 'ranged',
    "blaster": 'ranged',
    "gun": 'ranged',


    axes: 'melee',
    blunt_weapons: 'melee',
    bulwarks: 'melee',
    claws: 'melee',
    polearms: 'melee',
    pickaxes: 'melee',
    scythes: 'melee',
    slashing_swords: 'melee',
    slash_swords: 'melee',
    spiked_weapons: 'melee',
    stabbing_swords: 'melee',
    stab_swords: 'melee',
    'two-handed_swords': 'melee',
    whips: 'melee',
    guns: 'melee',
    polestaves: 'melee',
    salamanders: 'melee',
    //TODO Handle salamanders (all 3 styles)

    //ranged
    bows: 'ranged',
    crossbows: 'ranged',
    thrown_weapons: 'ranged',

    //magic
    staves: 'melee',
    bladed_staves: 'melee',
    powered_staves: 'melee',
    'trident-class_weapons': 'magic',
  };


  //TODO Depreceate
  equipBonus() {
    return this.calculateTotal();
  }

  /**
   * Total prayer drain
   * @returns {number}
   */
  prayerDrain() {
    let totalDrain = 0;
    for (let [key, prayer] of Object.entries(this.setup.prayers)) {
      console.log(prayer);
      totalDrain += prayer.drain_per_minute * 0.6;
    }
    
    if (totalDrain === 0) //Calculate a base natural drain
      totalDrain = 0.6;

    return totalDrain;
  }

  /**
   * If the player is in the wilderness
   * @returns boolean
   */
  inWilderness() {
    return this.setup.settings.inWilderness
  }

  slayerBoost() {
    if (!this.setup.settings.onTask)
      return 1;

    let blackMasks = [8901, 8903, 8905, 8907, 8909, 8911, 8913, 8915, 8917, 8919, 8921];
    let imbuedMask = [11774, 11775, 11776, 11777, 11778, 11779, 11780, 11781, 11782, 11783, 11784];
    let imbuedHelm = [11865, 19641, 19645, 19649, 21266, 21890, 23075, 24444,];
    let slayerHelm = [11864, 19639, 19643, 19647, 21264, 21888, 23073, 24370];

    let helmEquipped = blackMasks.includes(this.setup.equipment.head.id) || slayerHelm.includes(this.setup.equipment.head.id);
    let imbuedEquipped = imbuedMask.includes(this.setup.equipment.head.id) || imbuedHelm.includes(this.setup.equipment.head.id);

    switch (this.activeWeaponType()) {
      case 'melee':
        if (helmEquipped || imbuedEquipped)
          return (7 / 6); //We neeed decimals
        break;
      case 'ranged':
      case 'magic':
        if (imbuedEquipped)
          return 1.15;
    }
    return 1;
  }


  //Move to player
  salveBoost(monster) {
    if (!monster.isUndeadMonster())
      return 1;

    let salve = 4081;
    let salveI = 12017;
    let salveE = 10588;
    let salveEI = 12018;

    let equipped = this.isItemEquipped('neck', [salve, salveI, salveE, salveEI]);
    let enchantedEquipped = this.isItemEquipped('neck', [salveE, salveEI]);
    let imbuedEquipped = this.isItemEquipped('neck', [salveI, salveEI]);

    if (!equipped) {
      console.debug('salve not equipped', this.setup.equipment.neck.id);
      return 1;
    }

    switch (this.activeWeaponType()) {
      case 'melee':
        if (enchantedEquipped)
          return 1.20;
        return 1.15;
      case 'ranged':
      case 'magic':
        if (enchantedEquipped)
          return 1.20;
        if (imbuedEquipped)
          return 1.15;
    }
    return 1;
  }

  calculateTotal() {
    let total = {
      attack_stab: 0,
      attack_slash: 0,
      attack_crush: 0,
      attack_magic: 0,
      attack_ranged: 0,

      defence_stab: 0,
      defence_slash: 0,
      defence_crush: 0,
      defence_magic: 0,
      defence_ranged: 0,

      melee_strength: 0,
      ranged_strength: 0,
      magic_damage: 0,
      prayer: 0,
    };

    for (let [key, item] of Object.entries(this.setup.equipment)) {
      if (item.id === 0) {
        // console.log(`calculateTotal - Skipping ${key} - ${item.id} - invalid id`);
        continue;
      }

      if (this.isBlowpipeEquipped() && key === 'ammo') {
        continue; //We use the blowpipe_ammo instead
      }

      total = this.addStats(total, item.equipment)
    }

    return total
  }

  addStats(current, add) {
    return {
      attack_stab: current.attack_stab + add.attack_stab,
      attack_slash: current.attack_slash + add.attack_slash,
      attack_crush: current.attack_crush + add.attack_crush,
      attack_magic: current.attack_magic + add.attack_magic,
      attack_ranged: current.attack_ranged + add.attack_ranged,

      defence_stab: current.defence_stab + add.defence_stab,
      defence_slash: current.defence_slash + add.defence_slash,
      defence_crush: current.defence_crush + add.defence_crush,
      defence_magic: current.defence_magic + add.defence_magic,
      defence_ranged: current.defence_ranged + add.defence_ranged,

      melee_strength: current.melee_strength + add.melee_strength,
      ranged_strength: current.ranged_strength + add.ranged_strength,
      magic_damage: current.magic_damage + add.magic_damage,
      prayer: current.prayer + add.prayer,
    };
  }

  activeWeaponType() {
    let wepType = this.setup.equipment.weapon.weapon.weapon_type;
    console.log('activeWeaponType', wepType);

    if (this.setup.activeSpell !== null)
      return 'magic';

    return this.weaponTypes[wepType]
  }

  attackInterval() {
    if (this.activeWeaponType() === 'magic' && !this.isTridentEquipped())
      return 3; //TODO check

    if (this.activeWeaponType() === 'ranged' && this.setup.activeStance.combat_style === 'rapid') {
      if (this.setup.activeStance.boosts.indexOf('attack speed') !== -1) {
        return (this.setup.equipment.weapon.weapon.attack_speed - 1) * 0.6
      }
    }


    return this.setup.equipment.weapon.weapon.attack_speed * 0.6
  }

  prayerBonuses() {
    let total = {
      attack: 0,
      strength: 0,
      defence: 0,
      ranged: 0,
      magic: 0,
      ranged_strength: 0,
    };

    for (const key of Object.keys(this.setup.prayers)) {
      const p = this.setup.prayers[key].bonuses;

      for (const skillName of Object.keys(p)) {
        total[skillName] = p[skillName];
      }
    }

    return total;
  }

  /**
   * Returns the boosted level of a given skill
   * @param skill
   * @returns {Number}
   */
  visibleLevel(skill) {
    return this.getSkill(skill).level + this.potions.boosts()[skill];
  }

  /**
   * Returns the level of a given skill
   * @param skill
   * @returns {Number}
   */
  getLevel(skill) {
    return this.getSkill(skill).level
  }

  hitpointsLost() {
    if ('hitpointsLost' in this.player)
      return this.player.hitpoints.level - this.player.hitpointsLost;

    return 0;
  }

  /**
   * Returns the players skill
   * @param skill
   * @returns {Number}
   */
  getSkill(skill) {
    return this.player[skill]
  }


  voidSetDamageBonus() {
    let mageHelm = 11663;
    let rangedHelm = 11664;
    let meleeHelm = 11665;

    if (!this.isVoidSetEquipped())
      return 1;

    switch (this.setup.equipment.head.id) {
      case mageHelm:
        if (this.isEliteVoidEquipped()) {
          return 1.025;
        }
        return 1;
      case rangedHelm:
        if (this.isEliteVoidEquipped()) {
          return 1.125;
        }
        return 1.10;
      case meleeHelm:
        return 1.10;
    }
    return 1;
  }


  isTridentEquipped() {
    return this.setup.equipment.weapon.weapon.weapon_type === 'trident-class_weapons'
  }

  isBrimstoneRingEquipped() {
    return this.isWeaponEquipped(22975)
  }

  isDharoksEquipped() {
    let set = {
      head: 4716,
      body: 4720,
      legs: 4722,
      weapon: 4718,

    };
    return this.isArmourSetEquipped(set)
  }

  // Crystal armour "15% damage and 30% accuracy boost.",
  isCrystalArmourEquipped() {
    let set = {
      head: 23971,
      body: 23975,
      legs: 23979,
    };
    return this.isArmourSetEquipped(set)
  }

  isCrystalBowEquipped() {
    let weapons = [
      4212,
      4214,
      4215,
      4216,
      4217,
      4218,
      4219,
      4220,
      4221,
      4222,
      4223,
      11748,
      11749,
      11750,
      11751,
      11752,
      11753,
      11754,
      11755,
      11756,
      11757,
      11758,
      16889,
      23869,
      23901,
      23902,
      23903,
      23983,
      23985,
    ];

    return this.isWeaponEquipped(weapons)
  }

  /**
   * Returns the count of items worn within the set
   * @returns {number}
   */
  crystalArmourSetCount() {
    let set = {
      head: 23971,
      body: 23975,
      legs: 23979,
    };

    let count = 0;
    for (let [slot, id] of Object.entries(set)) {
      if (this.isItemEquipped(slot, id))
        count++
    }

    //Bow counts as part of set
    if (this.isCrystalBowEquipped())
      count++;

    return count;
  }

  isCrystalSetEquipped() {
    return this.isCrystalArmourEquipped() && this.isCrystalBowEquipped()
  }

  isObsidianSetEquipped() {
    return this.isObsidianWeaponEquipped() && this.isObsidianArmourEquipped()
  }

  isObsidianArmourEquipped() {
    let set = {
      head: 21298,
      body: 21301,
      legs: 21304,

    };
    return this.isArmourSetEquipped(set)
  }

  isObsidianWeaponEquipped() {
    let weapons = [
      //6522,// Toktz-xil-ul - Rings
      6523,// Toktz-xil-ak - Poker
      6525,// Toktz-xil-ek - Dagger
      6526,// Toktz-mej-tal - staff
      6527,// Tzhaar-ket-em - 1h maul
      6528,// Tzhaar-ket-om - maul
    ];

    return this.isWeaponEquipped(weapons)
  }


  /**
   * Returns if a armour set is equipped
   * @param set
   * @returns {boolean}
   */
  isArmourSetEquipped(set) {
    for (let [slot, id] of Object.entries(set)) {
      if (!this.isItemEquipped(slot, id))
        return false
    }

    return true;
  }

  /**
   * Returns if a weapon id or ids is equipped
   * @param weaponIds {Array|Number}
   * @returns {boolean|*}
   */
  isWeaponEquipped(weaponIds) {
    return this.isItemEquipped('weapon', weaponIds)
  }

  isItemEquipped(slot, itemIds) {
    if (Array.isArray(itemIds))
      return itemIds.includes(this.setup.equipment[slot].id);

    return this.setup.equipment[slot].id === itemIds
  }

  isBlowpipeEquipped() {
    return this.isWeaponEquipped(12926);
  }

  isVoidSetEquipped() {
    return (this.isEliteVoidEquipped() || this.isNormalVoidEquipped());
  }

  isEliteVoidEquipped() {
    let set = {
      head: [11663, 11664, 11665],
      body: 13072,
      legs: 13073,
      hands: 8842,
    };

    return this.isArmourSetEquipped(set)
  }

  isNormalVoidEquipped() {
    let set = {
      head: [11663, 11664, 11665],
      body: 8839,
      legs: 8840,
      hands: 8842,
    };

    return this.isArmourSetEquipped(set);
  }

  stanceKey() {
    switch (this.activeWeaponType()) {
      case 'melee':
        return this.setup.activeStance.attack_type;
      case 'ranged':
        return 'ranged';
      case 'magic':
        return 'magic';
      default:
        //Most likely unarmed
        return 'crush';
    }
  }

  stanceBonus_mellee() {
    switch (this.setup.activeStance.attack_style) {
      case "accurate":
        return 0;
      case "aggressive":
        return 3;
      case "controlled":
        return 1;
      default:
        return 0
    }
  }

  stanceBonus_ranged() {
    switch (this.setup.activeStance.combat_style) {
      case "accurate":
        return 3;
      case "rapid":
        return 0;
      case "longrange":
        return 0;
      default:
        return 0
    }
  }

  stanceBonus_magic() {
    if (this.isTridentEquipped()) { //TODO i think this needs to be removed
      switch (this.setup.activeStance.combat_style) {
        case "accurate":
          return 3;
        case "longrange":
          return 1;
        default:
          return 0
      }
    }

    return 0
  }
}



// WEBPACK FOOTER //
// ./src/js/player.js